import { createListenerMiddleware, createSlice, TypedStartListening } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from 'store/store';

import { SORTING_KEY } from 'constants/general';

import { setSorting } from './actions';
import { initialState } from './state';

export const sortingSlice = createSlice({
  name: 'sorting',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setSorting, (state, { payload }) => {
      state[payload.option] = payload.key as never;
    });
  },
});

export const sortingMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;

const startAppListening = sortingMiddleware.startListening as AppStartListening;

startAppListening({
  actionCreator: setSorting,
  effect: (_, listenerApi) => {
    const sorting = listenerApi.getState().sorting;

    localStorage.setItem(SORTING_KEY, JSON.stringify(sorting));
  },
});
